<div
  class="app-shell-wrapper"
  [ngStyle]="{ 'flex-direction': isMobileScreen ? 'column' : 'row' }"
  data-cy="app-shell-wrapper"
>
  <!-- Mobile Navigation Bar -->
  <div *ngIf="isMobileScreen" class="mobile-dropdown">
    <div class="mobile-header">
      <img
        [src]="
          subdomainType === SubdomainTypes.EagleProcessing
            ? '../../assets/eagle-logo.png'
            : this.applicationProfile.PortalTheme.PrimaryLogo
        "
        alt="image"
        class="logo-image-mobile"
      />

      <fa-icon
        [icon]="icons['faBars']"
        class="header-icon"
        (click)="onToggleMobileDropdown()"
        data-cy="mobile-nav-toggle"
      ></fa-icon>
    </div>

    <div class="dropdown-content" *ngIf="showMobileDropdown">
      <div class="d-flex flex-column">
        <a
          *ngIf="shouldShowMenuItem(AccessType.SaleOverview)"
          class="nav-link"
          [routerLink]="this.applicationProfile.Location.LocationId + '/dashboard'"
          routerLinkActive="active"
          [pTooltip]="isSmallScreen ? 'Dashboard' : ''"
          (click)="onToggleMobileDropdown()"
        >
          <div class="nav-link-content">
            <fa-icon [icon]="icons['faChartBar']" class="mr-3" />
            <span class="nav-label">Dashboard</span>
          </div>
        </a>
        <a
          *ngIf="shouldShowMenuItem(AccessType.OfferAdmin)"
          class="nav-link"
          [routerLink]="this.applicationProfile.Location.LocationId + '/offers'"
          routerLinkActive="active"
          [pTooltip]="isSmallScreen ? 'Offers' : ''"
          data-cy="nav-offers-mobile"
          (click)="onToggleMobileDropdown()"
        >
          <div class="nav-link-content">
            <fa-icon [icon]="icons['faMoneyBill']" [fixedWidth]="true" class="mr-3" />
            <span class="nav-label">Offers</span>
          </div>
        </a>
        <a
          *ngIf="shouldShowMenuItem(AccessType.ConsumerAccess)"
          class="nav-link"
          [routerLink]="this.applicationProfile.Location.LocationId + '/members'"
          [queryParams]="listQueryParams['members']"
          routerLinkActive="active"
          [pTooltip]="isSmallScreen ? 'Members' : ''"
          (click)="onToggleMobileDropdown()"
        >
          <div class="nav-link-content">
            <fa-icon [icon]="icons['faUsers']" [fixedWidth]="true" class="mr-3" />
            <span class="nav-label">Members</span>
          </div>
        </a>
        <a
          *ngIf="shouldShowMenuItem(AccessType.ConsumerAccess)"
          class="nav-link"
          [routerLink]="this.applicationProfile.Location.LocationId + '/non-members'"
          [queryParams]="listQueryParams['non-members']"
          routerLinkActive="active"
          [pTooltip]="isSmallScreen ? 'Non Members' : ''"
          (click)="onToggleMobileDropdown()"
        >
          <div class="nav-link-content">
            <i class="bi bi-person-x mr-3"></i>
            <span class="nav-label">Non Members</span>
          </div>
        </a>
        <a
          *ngIf="shouldShowMenuItem(AccessType.OrderAdmin)"
          class="nav-link"
          [routerLink]="this.applicationProfile.Location.LocationId + '/transactions'"
          [queryParams]="listQueryParams['transactions']"
          routerLinkActive="active"
          [pTooltip]="isSmallScreen ? 'Transactions' : ''"
          (click)="onToggleMobileDropdown()"
        >
          <div class="nav-link-content">
            <fa-icon [icon]="icons['faCreditCard']" [fixedWidth]="true" class="mr-3" />
            <span class="nav-label">Transactions</span>
          </div>
        </a>
        <a
          *ngIf="shouldShowMenuItem(AccessType.ReportAdmin)"
          class="nav-link"
          [routerLink]="this.applicationProfile.Location.LocationId + '/reports'"
          routerLinkActive="active"
          [pTooltip]="isSmallScreen ? 'Reports' : ''"
          (click)="onToggleMobileDropdown()"
        >
          <div class="nav-link-content">
            <fa-icon [icon]="icons['faFileExport']" [fixedWidth]="true" class="mr-3" />
            <span class="nav-label">Reports</span>
          </div>
        </a>
      </div>
      <!-- Change the activeIndex to 0 when the Merchant Accordion is back -->
      <p-accordion styleClass="side-nav-accordion" [activeIndex]="2" [collapseIcon]="" [expandIcon]="">
        <p-accordionTab *ngIf="shouldShowMenuItem(AccessType.OrderAdmin)" iconPos="end">
          <ng-template pTemplate="header">
            <div class="accordionNav">
              <div class="theme-text-color d-flex gap-3 ml-1">
                <fa-icon [icon]="icons['faGear']" />
                <span class="theme-text-color" class="mr-3"> Admin </span>
              </div>
            </div>
          </ng-template>
          <div class="d-flex flex-column">
            <ng-container *ngTemplateOutlet="devicesNavLink" />
            <a
              class="nav-link"
              [routerLink]="this.applicationProfile.Location.LocationId + '/admin/locations'"
              routerLinkActive="active"
              [pTooltip]="isSmallScreen ? 'Locations' : ''"
              (click)="onToggleMobileDropdown()"
            >
              <div class="nav-link-content">
                <fa-icon [icon]="icons['faStore']" [fixedWidth]="true" class="mr-3" />
                <span class="nav-label">Locations</span>
              </div>
            </a>

            <a
              class="nav-link"
              [routerLink]="this.applicationProfile.Location.LocationId + '/admin/employees'"
              [queryParams]="listQueryParams['admin/employees']"
              routerLinkActive="active"
              [pTooltip]="isSmallScreen ? 'Employees' : ''"
              (click)="onToggleMobileDropdown()"
            >
              <div class="nav-link-content">
                <fa-icon [icon]="icons['faUsersCog']" [fixedWidth]="true" class="mr-3" />
                <span class="nav-label">Employees</span>
              </div>
            </a>

            <a
              class="nav-link"
              [routerLink]="this.applicationProfile.Location.LocationId + '/admin/loyalty-program'"
              routerLinkActive="active"
              [pTooltip]="isSmallScreen ? 'Loyalty Program' : ''"
              (click)="onToggleMobileDropdown()"
            >
              <div class="nav-link-content">
                <fa-icon [icon]="icons['faStar']" [fixedWidth]="true" class="mr-3" />
                <span class="nav-label">Loyalty Program</span>
              </div>
            </a>

            <a
              class="nav-link"
              [routerLink]="this.applicationProfile.Location.LocationId + '/admin/questions'"
              [queryParams]="listQueryParams['admin/questions']"
              routerLinkActive="active"
              [pTooltip]="isSmallScreen ? 'Questions' : ''"
              (click)="onToggleMobileDropdown()"
            >
              <div class="nav-link-content">
                <fa-icon [icon]="icons['faPollH']" [fixedWidth]="true" class="mr-3" />
                <span class="nav-label">Questions</span>
              </div>
            </a>

            <!-- TODO: ticket#2683 reuse this component with new Invoice module.
            <a
              class="nav-link"
              [routerLink]="this.applicationProfile.Location.LocationId + '/admin/invoices'"
              routerLinkActive="active"
              [pTooltip]="isSmallScreen ? 'Invoices' : ''"
              (click)="onToggleMobileDropdown()"
            >
              <div class="nav-link-content">
                <fa-icon [icon]="icons['faFileInvoice']" [fixedWidth]="true" class="mr-3" />
                <span class="nav-label">Invoices</span>
              </div>
            </a> -->
          </div>
        </p-accordionTab>

        <p-accordionTab
          *ngIf="!shouldShowMenuItem(AccessType.OrderAdmin) && shouldShowMenuItem(AccessType.DeviceAdmin)"
          iconPos="end"
        >
          <ng-template pTemplate="header">
            <div class="accordionNav">
              <div class="theme-text-color d-flex gap-3 ml-1">
                <fa-icon [icon]="icons['faGear']" />
                <span class="theme-text-color" class="mr-3"> Admin </span>
              </div>
            </div>
          </ng-template>
          <div class="d-flex flex-column">
            <ng-container *ngTemplateOutlet="devicesNavLink" />
          </div>
        </p-accordionTab>
      </p-accordion>
    </div>
  </div>

  <!-- Tablet/Desktop Navigation Bar -->
  <div
    *ngIf="!isMobileScreen"
    [ngClass]="{
      'minimized-sidebar': (isSmallScreen && !shouldShowFullWidth) || !shouldShowFullWidth
    }"
  >
    <div class="side-navigation-bar">
      <div class="side-navigation-bar-header">
        <img [src]="getImageSrc()" alt="image" class="logo-image" />
      </div>

      <div class="d-flex flex-column">
        <a
          *ngIf="shouldShowMenuItem(AccessType.SaleOverview)"
          class="nav-link"
          [routerLink]="this.applicationProfile.Location.LocationId + '/dashboard'"
          routerLinkActive="active"
          [pTooltip]="isSmallScreen ? 'Dashboard' : ''"
        >
          <div class="nav-link-content">
            <fa-icon [icon]="icons['faChartBar']" size="lg" class="ml-1" />
            <span class="nav-label">Dashboard</span>
          </div>
        </a>
        <a
          *ngIf="shouldShowMenuItem(AccessType.OfferAdmin)"
          class="nav-link"
          [routerLink]="this.applicationProfile.Location.LocationId + '/offers'"
          routerLinkActive="active"
          [pTooltip]="isSmallScreen ? 'Offers' : ''"
          data-cy="nav-offers-mobile"
        >
          <div class="nav-link-content">
            <fa-icon [icon]="icons['faMoneyBill']" size="lg" [fixedWidth]="true" class="ml-1" />
            <span class="nav-label">Offers</span>
          </div>
        </a>
        <a
          *ngIf="shouldShowMenuItem(AccessType.ConsumerAccess)"
          class="nav-link"
          [routerLink]="this.applicationProfile.Location.LocationId + '/members'"
          [queryParams]="listQueryParams['members']"
          routerLinkActive="active"
          [pTooltip]="isSmallScreen ? 'Members' : ''"
        >
          <div class="nav-link-content">
            <fa-icon [icon]="icons['faUsers']" size="lg" [fixedWidth]="true" class="ml-1" />
            <span class="nav-label">Members</span>
          </div>
        </a>

        <a
          *ngIf="shouldShowMenuItem(AccessType.ConsumerAccess)"
          class="nav-link"
          [routerLink]="this.applicationProfile.Location.LocationId + '/non-members'"
          [queryParams]="listQueryParams['non-members']"
          routerLinkActive="active"
          [pTooltip]="isSmallScreen ? 'Non Members' : ''"
        >
          <div class="nav-link-content">
            <i class="bi bi-person-x ml-1" style="font-size: 20px"></i>
            <span class="nav-label">Non Members</span>
          </div>
        </a>
        <a
          *ngIf="shouldShowMenuItem(AccessType.OrderAdmin)"
          class="nav-link"
          [routerLink]="this.applicationProfile.Location.LocationId + '/transactions'"
          [queryParams]="listQueryParams['transactions']"
          routerLinkActive="active"
          [pTooltip]="isSmallScreen ? 'Transactions' : ''"
        >
          <div class="nav-link-content">
            <fa-icon [icon]="icons['faCreditCard']" size="lg" [fixedWidth]="true" class="ml-1" />
            <span class="nav-label">Transactions</span>
          </div>
        </a>
        <a
          *ngIf="shouldShowMenuItem(AccessType.ReportAdmin)"
          class="nav-link"
          [routerLink]="this.applicationProfile.Location.LocationId + '/reports'"
          routerLinkActive="active"
          [pTooltip]="isSmallScreen ? 'Reports' : ''"
        >
          <div class="nav-link-content">
            <fa-icon [icon]="icons['faFileExport']" size="lg" [fixedWidth]="true" class="ml-1" />
            <span class="nav-label">Reports</span>
          </div>
        </a>
      </div>

      <!-- Your side navigation bar content here -->
      <p-accordion
        styleClass="side-nav-accordion"
        [activeIndex]="activeMenuAccordionIndex"
        [collapseIcon]=""
        [expandIcon]=""
      >
        <p-accordionTab *ngIf="shouldShowMenuItem(AccessType.OrderAdmin)" iconPos="end">
          <ng-template pTemplate="header">
            <div class="accordionNav">
              <div class="theme-text-color d-flex gap-3 ml-1">
                <fa-icon [icon]="icons['faGear']" size="lg" />

                <span *ngIf="shouldShowFullWidth" class="theme-text-color ml-1"> Admin </span>
              </div>
            </div>
          </ng-template>
          <div class="d-flex flex-column">
            <ng-container *ngTemplateOutlet="devicesNavLink"></ng-container>

            <a
              class="nav-link"
              [routerLink]="this.applicationProfile.Location.LocationId + '/admin/locations'"
              routerLinkActive="active"
              [pTooltip]="isSmallScreen ? 'Locations' : ''"
            >
              <div class="nav-link-content">
                <fa-icon [icon]="icons['faStore']" size="lg" [fixedWidth]="true" class="ml-1" />
                <span class="nav-label">Locations</span>
              </div>
            </a>

            <a
              class="nav-link"
              [routerLink]="this.applicationProfile.Location.LocationId + '/admin/employees'"
              [queryParams]="listQueryParams['admin/employees']"
              routerLinkActive="active"
              [pTooltip]="isSmallScreen ? 'Employees' : ''"
            >
              <div class="nav-link-content">
                <fa-icon [icon]="icons['faUsersCog']" size="lg" [fixedWidth]="true" class="ml-1" />
                <span class="nav-label">Employees</span>
              </div>
            </a>

            <a
              class="nav-link"
              [routerLink]="this.applicationProfile.Location.LocationId + '/admin/loyalty-program'"
              routerLinkActive="active"
              [pTooltip]="isSmallScreen ? 'Loyalty Program' : ''"
            >
              <div class="nav-link-content">
                <fa-icon [icon]="icons['faStar']" size="lg" [fixedWidth]="true" class="ml-1" />
                <span class="nav-label">Loyalty Program</span>
              </div>
            </a>

            <a
              class="nav-link"
              [routerLink]="this.applicationProfile.Location.LocationId + '/admin/questions'"
              [queryParams]="listQueryParams['admin/questions']"
              routerLinkActive="active"
              [pTooltip]="isSmallScreen ? 'Questions' : ''"
            >
              <div class="nav-link-content">
                <fa-icon [icon]="icons['faPollH']" size="lg" [fixedWidth]="true" class="ml-1" />
                <span class="nav-label">Questions</span>
              </div>
            </a>

            <!-- TODO: ticket#2683 reuse this component with new Invoice module.
            <a
              class="nav-link"
              [routerLink]="this.applicationProfile.Location.LocationId + '/admin/invoices'"
              routerLinkActive="active"
              [pTooltip]="isSmallScreen ? 'Invoices' : ''"
            >
              <div class="nav-link-content">
                <fa-icon [icon]="icons['faFileInvoice']" size="lg" [fixedWidth]="true" class="ml-1" />
                <span class="nav-label">Invoices</span>
              </div>
            </a> -->
          </div>
        </p-accordionTab>

        <p-accordionTab
          *ngIf="!shouldShowMenuItem(AccessType.OrderAdmin) && shouldShowMenuItem(AccessType.DeviceAdmin)"
          iconPos="end"
        >
          <ng-template pTemplate="header">
            <div class="accordionNav">
              <div class="theme-text-color d-flex gap-3 ml-1">
                <fa-icon [icon]="icons['faGear']" size="lg" />
                <span *ngIf="shouldShowFullWidth" class="theme-text-color ml-1"> Admin </span>
              </div>
            </div>
          </ng-template>
          <div class="d-flex flex-column">
            <ng-container *ngTemplateOutlet="devicesNavLink"></ng-container>
          </div>
        </p-accordionTab>
      </p-accordion>
    </div>
  </div>

  <!-- Main Content -->
  <div class="main-content">
    <app-header (closeClicked)="onCloseClicked()"></app-header>
    <div class="app-content">
      <!-- Your main content, including header and router-outlet -->
      <div *ngIf="!isLoading" id="merchant-portal-routing-wrapper">
        <router-outlet></router-outlet>
      </div>
      <app-loading-spinner *ngIf="isLoading" [message]="'Loading...'" class="text-center"></app-loading-spinner>
    </div>
  </div>
</div>

<ng-template #devicesNavLink>
  <a
    class="nav-link"
    [routerLink]="this.applicationProfile.Location.LocationId + '/admin/devices'"
    [queryParams]="listQueryParams['admin/devices']"
    routerLinkActive="active"
    [pTooltip]="isSmallScreen ? 'Devices' : ''"
    (click)="isMobileScreen ? onToggleMobileDropdown() : null"
  >
    <div class="nav-link-content">
      <fa-icon [icon]="icons['faCalculator']" size="lg" [fixedWidth]="true" class="ml-1" />
      <span class="nav-label">Devices</span>
    </div>
  </a>
</ng-template>
